module.exports = __webpack_public_path__ + "img/logo-gray.d176c630.png";